export default {
	data() {
		return {
			entityName: 'device',
			moduleName: 'devices',
			detailPageRouteName: 'deviceDetail',
			entity: {},
			updateFields: [
				'id_profile',
				'id_subscriber',
				'name',
				'pre_provisioned',
				'use_dhcp',
				'id_last_subscriber_profile',
				'remember_subscriber_profile',
			],
		}
	},
	methods: {
		_processDetailErrorMessage(error) {
			return this.processErrorMessage(error)
		},
		processErrorMessage(error) {
			this._.forEach(error['validation_errors'], function (errorMessage) {
				error['error_message'] = errorMessage
			});
			return error['error_message'];
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/devices/mixins/devices.js